<template>
  <header>
    <div class="pc-only">
      <div class="width">
        <div class="logo">
          <router-link to="/">
            <img src="../../../static/assets/img/logo_new.png" />
          </router-link>
        </div>
        <nav class="navi">
          <!-- <ul>
            <router-link to="/">서비스소개</router-link>
          </ul> -->
          <ul>
            <router-link to="/services/notices">고객지원</router-link>
          </ul>
          <ul>
            <router-link to="/orders/form">주문접수</router-link>
          </ul>
        </nav>
        <nav class="account" v-if="$store.getters['auth/isAuthenticated']()">
          <ul>
            <router-link to="/my/info"
              >{{ $store.getters["auth/tokenPayload"]().name }}님</router-link
            >
          </ul>
          <ul class="signout" v-on:click="signout()">
            로그아웃
          </ul>
        </nav>
        <nav class="account" v-if="!$store.getters['auth/isAuthenticated']()">
          <ul>
            <router-link to="/join/intro">회원가입</router-link>
          </ul>
          <ul>
            <router-link to="/users/signin">로그인</router-link>
          </ul>
        </nav>
      </div>
    </div>
    <div class="head mobile-only">
      <div class="logo">
        <router-link to="/" @click.native="navopen = false">
          <img src="../../../static/assets/img/logo_new.png" />
        </router-link>
      </div>
      <div class="menu-btn-wrap">
        <button @click="navopen = !navopen">
          <i class="far fa-bars fa-fw" />
        </button>
      </div>
    </div>

    <div class="mobile-menu mobile-only" v-if="navopen">
      <router-link to="/services/notices" @click.native="navopen = !navopen">
        <li>
          <span>고객지원</span>
        </li>
      </router-link>
      <router-link to="/orders/form" @click.native="navopen = !navopen">
        <li>
          <span>주문접수</span>
        </li>
      </router-link>
      <router-link
        to="/join/intro"
        v-if="!$store.getters['auth/isAuthenticated']()"
        @click.native="navopen = !navopen"
      >
        <li>
          <span>회원가입</span>
        </li>
      </router-link>

      <router-link
        to="/users/signin"
        v-if="!$store.getters['auth/isAuthenticated']()"
      >
        <li>
          <span>로그인</span>
        </li>
      </router-link>
      <router-link
        to="/my/info"
        v-if="$store.getters['auth/isAuthenticated']()"
        @click.native="navopen = !navopen"
      >
        <li>
          <span>{{ $store.getters["auth/tokenPayload"]().name }}님</span>
        </li>
      </router-link>
      <li v-if="$store.getters['auth/isAuthenticated']()" v-on:click="signout">
        <span>로그아웃</span>
      </li>
    </div>
  </header>
</template>

<script>
import channelTalk from "@/helpers/channelTalk";
/* eslint-disable */
export default {
  data() {
    return {
      navopen: false,
      sideBar: false,
    };
  },
  mounted() {
    // console.log(this.$store.getters['auth/isAuthenticated']());
  },
  methods: {
    alertSignup() {
      alert("시범서비스 기간 중 신규회원가입은 불가능합니다");
    },
    async signout() {
      this.navopen = false;
      this.$store.dispatch("auth/signout");
      channelTalk.shutdown();
      this.$router.push("/");
    },
  },
};
</script>

<style src="./header.css" scoped></style>
